import { Controller } from "@hotwired/stimulus"
import { readerFindShortcut } from "../reader_keyboard_shortcut.js"

export default class extends Controller {
  static targets = ["input"]

  focus(event) {
    if (!readerFindShortcut(event)) return

    event.preventDefault()
    this.inputTarget.focus()
  }
}
